import { ColorPicker, NumberInput, BorderStylePicker } from "../../../../../components/shared/Forms";

const Card = () => {
	return (
		<div className="theme-content">
			<BorderStylePicker
				field="borderStyle"
				id="borderStyle"
				placeholder="Border Styles"
				themeBuilderInputType="BorderStylePicker"
			/>
			<ColorPicker
				field="borderColor"
				id="borderColor"
				placeholder="Border Color"
				themeBuilderInputType="ColorPicker"
			/>
			<NumberInput
				field="borderWidth"
				id="borderWidth"
				placeholder="Border Width"
				themeBuilderInputType="NumberInput"
			/>
			<NumberInput
				field="borderRadius"
				id="borderRadius"
				placeholder="Border Radius"
				max={768}
				themeBuilderInputType="NumberInput"
			/>
			<ColorPicker
				field="backgroundColor"
				id="backgroundColor"
				placeholder="Background Color"
				themeBuilderInputType="ColorPicker"
			/>
			<ColorPicker
				field="textColor"
				id="textColor"
				placeholder="Text Color"
				themeBuilderInputType="ColorPicker"
			/>
			<ColorPicker
				field="highlightColor"
				id="highlightColor"
				placeholder="Highlight Color"
				themeBuilderInputType="ColorPicker"
			/>
			<NumberInput
				field="paddingHorizontal"
				id="paddingHorizontal"
				placeholder="Horizontal Padding"
				themeBuilderInputType="NumberInput"
			/>
			<NumberInput
				field="paddingVertical"
				id="paddingVertical"
				placeholder="Vertical Padding"
				themeBuilderInputType="NumberInput"
			/>
		</div>
	);
};

export default Card;
